module.exports = __webpack_public_path__ + "media/images/webpage/hotels/3105/plan2-1-13a7856f9c597e19f68f6913fad79da8.webp";